var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"0","rounded":"0","flat":""}},[_c('MarqetaVirtualCard',{attrs:{"token":_vm.token,"cardOnly":_vm.cardOnly,"elevation":_vm.elevation,"magicLink":_vm.magicLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }